import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

export default (state, props) => getRecordSelector(state, props)
